/**
 * Confirmation in-app remplaçant window.confirm().
 *
 * Pourquoi : Safari iOS peut supprimer silencieusement les dialogues natifs
 * (option « Ignorer les boîtes de dialogue » / suppression automatique après
 * plusieurs affichages). confirm() renvoie alors false SANS rien afficher et
 * tous les boutons qui en dépendent semblent morts sur iPhone/iPad.
 *
 * Usage : `if (!(await confirmDialog("Valider ?"))) return;`
 * Le <ConfirmHost /> doit être monté une fois (App.js).
 */
import { useEffect, useState } from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

let _show = null;

export function confirmDialog(message, opts = {}) {
  return new Promise((resolve) => {
    if (_show) _show({ message, title: opts.title, okLabel: opts.okLabel, resolve });
    else resolve(window.confirm(message)); // fallback si host non monté
  });
}

export function ConfirmHost() {
  const [req, setReq] = useState(null);
  useEffect(() => {
    _show = setReq;
    return () => { _show = null; };
  }, []);
  const done = (val) => {
    req?.resolve(val);
    setReq(null);
  };
  return (
    <AlertDialog open={!!req} onOpenChange={(o) => { if (!o) done(false); }}>
      <AlertDialogContent data-testid="confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>{req?.title || "Confirmation"}</AlertDialogTitle>
          <AlertDialogDescription className="whitespace-pre-line">{req?.message}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={() => done(false)} data-testid="confirm-cancel-btn">Annuler</AlertDialogCancel>
          <AlertDialogAction onClick={() => done(true)} data-testid="confirm-ok-btn" style={{ background: "var(--brand)", color: "#fff" }}>
            {req?.okLabel || "Confirmer"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
